import { render } from "./DokumendidLeht.vue?vue&type=template&id=6e7c325d&scoped=true&ts=true"
import script from "./DokumendidLeht.vue?vue&type=script&lang=ts"
export * from "./DokumendidLeht.vue?vue&type=script&lang=ts"

import "./DokumendidLeht.vue?vue&type=style&index=0&id=6e7c325d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7c325d"]])

export default __exports__